/* unplugin-vue-components disabled */import { render } from "./SearchByPublisher.vue?vue&type=template&id=245c3bfc&ts=true"
import script from "./SearchByPublisher.vue?vue&type=script&lang=ts"
export * from "./SearchByPublisher.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__